import { render } from "./SalesForecast.vue?vue&type=template&id=eefcf5b0&scoped=true"
import script from "./SalesForecast.vue?vue&type=script&lang=js"
export * from "./SalesForecast.vue?vue&type=script&lang=js"

import "./SalesForecast.vue?vue&type=style&index=0&id=eefcf5b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eefcf5b0"]])

export default __exports__